import React from 'react';
import WorkflowWaitingTimeViewModel from './WorkflowWaitingTime.viewmodel';

function WorkflowWaitingTimeView() {
    const { dashboardRef } = WorkflowWaitingTimeViewModel();

    return (
        <div className="h-screen w-full">
            <div
                ref={dashboardRef}
                style={{ width: '100%', height: '100%' }}
                className="superset-container h-full w-full [&_iframe]:h-full [&_iframe]:w-full"
            ></div>
        </div>
    );
}

export default WorkflowWaitingTimeView;
